import { Tag } from "antd";
import React from "react";
import { styled } from "styled-components";
import { Actions } from "../components/buttons/Actions";
import { GenericSwitch } from "../components/elements/Switch";
import { showMessage } from "../components/message/GenericMessage";
import { PRODUCTS_API } from "../constants/api";
import {
  actionsColumn,
  activeColumn,
  createdColumn,
} from "../constants/objects";
import { sProducts, sUGX } from "../constants/strings";
import { VARIABLE_STOCK } from "../constants/webapp";
import { useAppContext } from "../context/useAppContext";
import { ProductForm, stock_types } from "../forms/ProductForm";
import { dateTimeFormat, numberFormatter } from "../utils/formatter";
import { useReportStats } from "./common/useCommon";
import { useFirebase } from "./firebase/useFirebase";

export function getStockType(item) {
  if (!item?.stock_type) return "None";

  // return stock value
  if (item?.stock_type === VARIABLE_STOCK)
    return numberFormatter(item.stock) + " units";

  // get stock label
  return stock_types.find((val) => val.value === item?.stock_type).label;
}

export const useProducts = () => {
  const { contextData } = useAppContext();
  const { addData: addProduct, deleteData } = useFirebase();
  const { updateReportStats } = useReportStats();

  function DuplicateProduct(item) {
    item.product_name = item.product_name + " - Copy";
    item.active = false;

    // remove existing keys
    delete item.imageUrls;
    delete item?.docRef;
    delete item?.id;

    addProduct(PRODUCTS_API, item);
    showMessage("Processing...", "loading");
  }

  const productsTableData = (data) => [
    ...data.map((item) => {
      const row = {
        timestamp: dateTimeFormat(item?.timestamp),
        product_name: (
          <div>
            <p>{item.product_name}</p>
            <DescWrapper className="font11 thin lightColor ellipsis">
              {item.desc}
            </DescWrapper>
          </div>
        ),
        price: (
          <>
            <p>{numberFormatter(item.price)}</p>
            <s className="lightColor font12">
              {item.original_price !== 0 &&
                numberFormatter(item.original_price)}
            </s>
          </>
        ),
        del_fee: numberFormatter(item.del_fee),
        sold: (
          <Tag color="green" style={{ margin: 0 }}>
            {numberFormatter(item.sold)} units
          </Tag>
        ),
        stock: <Tag style={{ margin: 0 }}>{getStockType(item)}</Tag>,

        active: (
          <GenericSwitch end checked={item.active} docRef={item.docRef} />
        ),
        actions: (
          <Actions
            actions={[
              {
                action: "Duplicate",
                click: () => DuplicateProduct(item),
                confirm: true,
              },
              {
                action: "Delete",
                click: () => {
                  deleteData(item.docRef, item?.imageUrls);
                  updateReportStats(sProducts, -1);
                },
                confirm: true,
              },
            ]}
          />
        ),

        onclick: () =>
          contextData.showGlobalDrawer({
            component: <ProductForm data={item} />,
            title: "Update Product",
          }),
      };
      return row;
    }),
  ];

  const productsTableColumns = [
    { id: "product_name", title: "Product Name", align: "left" },
    {
      id: "price",
      tag: sUGX,
    },
    {
      id: "del_fee",
      title: "Delivery",
      tag: sUGX,
    },
    { id: "sold", title: "Sold" },
    { id: "stock", title: "Stock" },
    createdColumn,
    activeColumn,
    actionsColumn,
  ];
  return { productsTableData, productsTableColumns };
};

export const DescWrapper = styled.p`
  @media (max-width: 860px) {
    width: 200px;
  }
`;

export const UGXTag = () => <Tag style={{ margin: 0 }}>{sUGX}</Tag>;
